import { Box, Divider, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faPeopleGroup } from "@fortawesome/free-solid-svg-icons";

const iconStyle = {
  fontSize: 35,
  color: "#555",
};

const IndicatorValue = ({ data, unit, icon }) => {
  return (
    <Box sx={{ display: "grid", placeItems: "center", height: 100 }}>
      <Box>
        <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
          {icon && (
            <Box sx={{ width: 40, display: "flex", justifyContent: "center" }}>
              {icon}
            </Box>
          )}
          <Typography sx={{ fontSize: 40, fontWeight: "bold" }}>
            {data}
          </Typography>
        </Box>

        {unit && (
          <Box sx={{ width: 1, display: "flex", gap: 2 }}>
            <Box
              sx={{
                width: 40,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 1,
              }}
            >
              <Divider sx={{ width: 1 }} />
              <FontAwesomeIcon icon={faPeopleGroup} style={iconStyle} />
            </Box>

            <Typography sx={{ fontSize: 12, textAlign: "end" }}>
              {unit}
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};
export default IndicatorValue;
